module.exports = __webpack_public_path__ + "fonts/iconfont.17afde94.woff";